import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Modal } from 'containers/misc'
import { AssessorReport } from 'containers/sections/assessors'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button } from 'components/misc'
import { TasksAwardLeaderNote, TasksEvidence } from 'components/sections/tasks'
import { tasks as tasksLayout } from 'constants/layout'
import {PROGRESS_STATES} from "../../../../constants/enums";

export default class TasksResidentialProject extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onSignoffRequestResidentialProject: PropTypes.func.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    isAssessorManagementEnabled: PropTypes.bool,
    codeLists:PropTypes.object
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      activityIdApprove: null,
      activityIdReturn: null,
      assessorReport: {},
      activityAssessed: false,
      assessed: false,
      rpId: false,
      rpActionId: false,
      note: '',
      observations: null,
      fileUrls: []
    }
  }

  handleApproveModal = activityIdApprove => {
    this.setState(
      {
        activityIdApprove
      },
      () => {
        this.props.modal(`modal-approve-rp-${this.key}`)
      }
    )
  }

  handleReturnModal = activityIdReturn => {
    this.setState(
      {
        activityIdReturn
      },
      () => {
        this.props.modal(`modal-return-rp-${this.key}`)
      }
    )
  }

  handleShowAssessorNote = (rpId, rpActionId, assessed) => {
    this.setState(
      {
        rpId,
        rpActionId,
        assessed
      },
      () => {
        this.props.modal(`modal-assessor-note-show-${this.key}`)
      }
    )
  }

  handleShowNote = (id, requestId) => {
    this.props
      .onSignoffRequestResidentialProject(id, requestId)
      .then(({ body }) => {
        this.setState(
          {
            note: get(body, 'note')
          },
          () => {
            this.props.modal(`modal-note-show-${this.key}`)
          }
        )
      })
  }

  handleShowEvidence = (observations, fileUrls) => {
    this.setState(
      {
        observations,
        fileUrls
      },
      () => {
        this.props.modal(`modal-show-evidence-${this.key}`)
      }
    )
  }

  render() {
    const { data, approveModal, returnModal, isAssessorManagementEnabled, codeLists } = this.props

    const showReasons = get(data, 'state.value') === PROGRESS_STATES.activityApproval.id

    return (
      <div>
        <Table ths={tasksLayout.rpSignoffTableHeadersSingle}>
          <Data>
            <tr>
              <td>
                <Button
                  type="button"
                  intlKey="button.view"
                  link
                  onClick={() =>
                    this.handleShowEvidence(
                      get(data, 'observations'),
                      get(data, 'fileUrls')
                    )
                  }
                >
                  View
                </Button>
              </td>
              <td>
                <Button
                  type="button"
                  link
                  onClick={() =>
                    this.handleShowNote(
                      data.id,
                      data.residentialProjectSignoffRequestActionId
                    )
                  }
                >
                  <FormattedMessage id="button.view" defaultMessage="View" />
                </Button>
              </td>
              <td className="text--center">
                <ButtonGroup right>
                  <Button
                    type="button"
                    onClick={() =>
                      this.handleApproveModal(get(data, 'id'), { isRp: false })
                    }
                    intlKey="button.approve"
                    tiny
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    onClick={() =>
                      this.handleReturnModal(get(data, 'id'), { isRp: false })
                    }
                    intlKey="button.revise"
                    tiny
                    secondary
                  >
                    Revise
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <Modal
          id={`modal-note-show-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <TasksAwardLeaderNote note={this.state.note} />
        </Modal>
        <Modal id={`modal-assessor-note-show-${this.key}`} closeAction="Close">
          <AssessorReport
            id={this.state.rpId}
            actionId={this.state.rpActionId}
            assessed={this.state.assessed}
            isResidentialProject
          />
        </Modal>
        <Modal id={`modal-approve-rp-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.activityIdApprove}
            modal={this.props.modal}
          />
        </Modal>
        <Modal id={`modal-return-rp-${this.key}`} customActions enableOverflow>
          <TaskReturn
            returnTask={returnModal}
            id={this.state.activityIdReturn}
            modal={this.props.modal}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
            showReasons={showReasons}
          />
        </Modal>
        <Modal id={`modal-show-evidence-${this.key}`}>
          <TasksEvidence
            observations={this.state.observations}
            fileUrls={this.state.fileUrls}
          />
        </Modal>
      </div>
    )
  }
}
